import type { NFStatus } from "@/data/mock";
import { cn } from "@/lib/utils";

const map: Record<NFStatus, { cls: string }> = {
  "Pendente":     { cls: "bg-yellow-500/15 text-yellow-700 border border-yellow-500/30 dark:text-yellow-400" },
  "A validar":    { cls: "bg-yellow-500/15 text-yellow-700 border border-yellow-500/30 dark:text-yellow-400" },
  "Válido":       { cls: "bg-blue-500/15 text-blue-700 border border-blue-500/30 dark:text-blue-400" },
  "CNPJ Inválido":{ cls: "bg-orange-500/15 text-orange-700 border border-orange-500/30 dark:text-orange-400" },
  "Erro OCR":     { cls: "bg-gray-500/15 text-gray-600 border border-gray-500/30" },
  "Em análise":   { cls: "bg-primary/15 text-primary border border-primary/30" },
  "Aprovada":     { cls: "bg-success/15 text-success border border-success/30" },
  "Recusada":     { cls: "bg-destructive/15 text-destructive border border-destructive/30" },
  "Cancelada":    { cls: "bg-zinc-500/15 text-zinc-600 border border-zinc-500/30 dark:text-zinc-400" },
  "Com ressalvas":{ cls: "bg-amber-500/15 text-amber-700 border border-amber-500/30 dark:text-amber-400" },
};

export const StatusBadge = ({ status }: { status: NFStatus | string }) => {
  const entry = map[status as NFStatus];
  const cls = entry?.cls ?? "bg-muted text-muted-foreground border border-border";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        cls,
      )}
    >
      {status}
    </span>
  );
};
